import { render, staticRenderFns } from "./PreparacaoAmbienteBroker.vue?vue&type=template&id=4650b53f&scoped=true&"
import script from "./PreparacaoAmbienteBroker.vue?vue&type=script&lang=js&"
export * from "./PreparacaoAmbienteBroker.vue?vue&type=script&lang=js&"
import style0 from "./PreparacaoAmbienteBroker.vue?vue&type=style&index=0&id=4650b53f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4650b53f",
  null
  
)

export default component.exports